const CLASS_OPEN_NAV = 'nav--open';
const CLASS_OPEN_SUBNAV = 'level--open';
const CLASS_NO_SCROLL = 'no--scroll';
const CLASS_OPEN = 'is--open';

const body = document.querySelector('body');
const burgerMenu = document.querySelector('.js-menu-button');
const burgerMenuCloseBtn = document.querySelector('[data-burger-menu-close]');
const navigation = document.querySelector('.js-navigation-menu');
const subMenuToggles = document.querySelectorAll('.js-toggle-submenu');
const navigationSubLevel = '.js-sub-level';
const backButtons = document.querySelectorAll('.js-menu-back');
const languageButton = document.querySelector('.js-language-selector');
const { parentElement: languageParent } = languageButton ?? {};

burgerMenu.addEventListener('click', toggleMenu);
burgerMenuCloseBtn?.addEventListener('click', toggleMenu);

for (const toggle of subMenuToggles) {
	toggle.addEventListener('click', toggleSubMenu);
}
for (const button of backButtons) {
	button.addEventListener('click', toggleSubMenu);
}

function toggleMenu(e) {
	e.preventDefault();

	const isOpen = navigation.classList.toggle(CLASS_OPEN_NAV);
	body.classList.toggle(CLASS_NO_SCROLL, isOpen);
	languageParent?.classList.remove(CLASS_OPEN);
}

function toggleSubMenu() {
	this.closest(navigationSubLevel).classList.toggle(CLASS_OPEN_SUBNAV);
}
